// src/models/taxonomy.ts
export type RawTaxonomy = {
  id: number
  name: string
  slug: string
  taxonomy: string
  count?: number
  parent?: number
  description?: string
  meta?: Record<string, unknown>
  acf?: Record<string, unknown>
}

export type TaxonomyModel = {
  id: number
  title: string
  slug: string
  taxonomy: string
  count?: number
  parent?: number
  excerpt?: string
  meta?: Record<string, unknown>
  acf?: Record<string, unknown>
}

const taxonomy = (p: RawTaxonomy): TaxonomyModel => ({
  id: p.id,
  title: p.name,
  slug: p.slug,
  taxonomy: p.taxonomy,
  count: p.count,
  parent: p.parent,
  excerpt: p.description,
  meta: p.meta,
  acf: p.acf,
})

export default taxonomy
